import React, { useContext, useState } from "react";

import supabase from "../supabase/supabaseClient";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from "../context/DataContext";

import estilo from "./styles/Ingreso.module.css";

function Ingreso() {
  let navigate = useNavigate();

  const { actualizarUsuario } = useContext(DataContext);

  const [alertaIngreso, setAlertaIngreso] = useState(null);
  const [formDatos, setFormDatos] = useState({
    correo: "",
    contraseña: "",
  });

  function capturarInputs(e) {
    setFormDatos((prevFormDatos) => {
      return {
        ...prevFormDatos,
        [e.target.name]: e.target.value,
      };
    });
  }

  async function ingresar(e) {
    e.preventDefault();
    const { data, error } = await supabase.auth.signInWithPassword({
      email: formDatos.correo,
      password: formDatos.contraseña,
    });

    if (data.user === null) {
      setAlertaIngreso("Verifique los datos ingresados");
    } else {
      actualizarEstado(data.user.id);
      actualizarUsuario(data.user);
      navigate("/");
    }

    if (error) {
      if (error.message === "Email not confirmed") {
        setAlertaIngreso("Falta confirmar correo");
      } else if (error.message === "Invalid login credentials") {
        setAlertaIngreso("Correo/Contraseña incorrectos");
      }
    }
  }

  async function actualizarEstado(e) {
    const { data, error } = await supabase
      .from("usuarios_chat")
      .update({ estado: true })
      .eq("user_id", e);
  }

  return (
    <div className={estilo.ingreso}>
      <div className={estilo.contenido}>
        <div className={estilo.descripcion}>
          <h2>
            S<em>Person</em>
          </h2>
          <p>Ingresa y habla con personas aletorias todo el tiempo</p>
        </div>

        <form onSubmit={ingresar}>
          <div className={estilo.input_datos}>
            <input
              type="text"
              name="correo"
              value={formDatos.correo}
              placeholder="Correo"
              onChange={capturarInputs}
            />
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"></path>
            </svg>
          </div>

          <div className={estilo.input_datos}>
            <input
              type="password"
              name="contraseña"
              inputMode="text"
              value={formDatos.contraseña}
              placeholder="Contraseña"
              onChange={capturarInputs}
            />
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M7 17a5.007 5.007 0 0 0 4.898-4H14v2h2v-2h2v3h2v-3h1v-2h-9.102A5.007 5.007 0 0 0 7 7c-2.757 0-5 2.243-5 5s2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"></path>
            </svg>
          </div>

          <button type="submit">Ingresar</button>
        </form>

        <div className={estilo.textos}>
          <div className={estilo.alerta}>
            {alertaIngreso && <p>{alertaIngreso}</p>}
          </div>

          <div className={estilo.detalles}>
            <p>
              Todavia no tienes una cuenta?{" "}
              <Link to={"/registro"}>Registrate</Link>
            </p>
          </div>
        </div>
      </div>

      {/* <br></br>
      <p>
        <b>kia: </b>qyajzrvvnuwvdfrkfj@bbitj.com
      </p>
      <p>
        <b>fola: </b>xigije6417@pyadu.com
      </p> */}
    </div>
  );
}

export default Ingreso;
